// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const MyAccountNavLinkStyles = css`
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  ${(props) =>
    `
    .nav-link-wrapper {
      padding: ${props.theme.spacing.ELEM_SPACING.LRG} 40px;
      border-bottom: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
    }
    .nav-link-wrapper:first-child {
      border-top: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
    }
    `}
  ${(props) =>
    `
      .nav-link-section a{
      font-family: ${props.theme.typography.fonts.secondary};
      font-size: ${props.theme.typography.fontSizes.fs16};
      color: ${props.theme.colors.BLACK};
      }
      .nav-link-sub-section{
        border:none;
      }
      .nav-link-sub-section:first-child {
      border-top: none;
    }
      .nav-link-sub-section a{
        font-family: ${props.theme.typography.fonts.secondary};
        font-size: ${props.theme.typography.fontSizes.fs14};
        color: ${props.theme.colors.BLACK};
      }
      &.active-nav-link,.active-sub-nav-link a{
        font-weight: ${props.theme.fonts.fontWeight.bold};
      }
      `}
  .nav-sub-section {
    padding-left: 0;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    border: none;
    li {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0 0
        ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }
`;

export default MyAccountNavLinkStyles;
